import React from 'react';

const Loader = ({
  size = 'large',
}: {
  size?: 'small' | 'medium' | 'large';
}) => {
  const sizeClass =
    size === 'small'
      ? 'loading-sm'
      : size === 'medium'
        ? 'loading-md'
        : 'loading-lg';

  return (
    <div className="h-screen w-full flex justify-center items-center">
      <span className={`${sizeClass} loading loading-spinner bg-blue`}></span>
    </div>
  );
};

export default Loader;
